import React from 'react';
import { CpPreviewRoute } from 'components/organisms/customer-portal/builder-components/tabs/design-tab/cp-preview-route';
import { CpFilesPreviewPage } from 'components/organisms/customer-portal/widgets/all-files/cp-files-preview-page';
import { CpSpaceTabPage } from 'components/organisms/customer-portal/widgets/space/cp-space-tab-page';
import { RoutePaths } from 'constant';
import { CustomSecureRoute } from 'routes/custom-secure-route';
import '../../tailwind.css';
import '../../index.css';

export const PortalBotRoutes = () => {
  return (
    <>
      <CustomSecureRoute
        path={RoutePaths.liveCustomerPortal}
        strict
        component={CpPreviewRoute}
      />
      <CustomSecureRoute
        path={RoutePaths.liveCustomerPortalWithoutProject}
        strict
        component={CpPreviewRoute}
      />
      <CustomSecureRoute
        path={RoutePaths.home}
        strict
        component={CpPreviewRoute}
      />

      <CustomSecureRoute path={RoutePaths.customerPortalAttachmentById} exact>
        <CpFilesPreviewPage />
      </CustomSecureRoute>

      <CustomSecureRoute path={RoutePaths.customerPortalSpaceTabById} exact>
        <CpSpaceTabPage />
      </CustomSecureRoute>
    </>
  );
};
